var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3C9 1.34315 10.3431 0 12 0C13.6569 0 15 1.34315 15 3C15 3.48801 14.8835 3.9488 14.6767 4.35607C16.1768 4.76269 17.5732 5.5091 18.7459 6.55152C20.5958 8.19584 21.7568 10.4596 21.9953 12.9028C22.0227 13.1836 21.9302 13.4629 21.7407 13.6719C21.5511 13.8808 21.2821 14 21 14H3C2.71788 14 2.44889 13.8808 2.25934 13.6719C2.06979 13.4629 1.97732 13.1836 2.00474 12.9028C2.24325 10.4596 3.4042 8.19584 5.25407 6.55152C6.42678 5.5091 7.82317 4.7627 9.32326 4.35607C9.11652 3.9488 9 3.48801 9 3ZM12 2C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4C12.5523 4 13 3.55228 13 3C13 2.44772 12.5523 2 12 2ZM12 6C9.99312 6 8.06189 6.73159 6.58279 8.04634C5.38813 9.10826 4.55803 10.4884 4.18369 12H19.8163C19.442 10.4884 18.6119 9.10826 17.4172 8.04634C15.9381 6.73159 14.0069 6 12 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 15C0.447715 15 0 15.4477 0 16C0 16.5523 0.447715 17 1 17H23C23.5523 17 24 16.5523 24 16C24 15.4477 23.5523 15 23 15H1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduction);
export default __webpack_public_path__ + "static/media/production.d460167e9ae03f6014fc354c73d5d990.svg";
export { ForwardRef as ReactComponent };